import React, { useState } from 'react';
import { render } from '@testing-library/react';
import { MAX_LETTERS, checkWordGuess, CheckedLetter } from './utils';

interface WordGuessProps {
    guess: string[];
    word: string;
    submitted: boolean;
}

export default function WordGuess({ guess, word, submitted }: WordGuessProps) {
    const answer = word.toUpperCase().split('');
    const checkedLetters: any[] = new Array(MAX_LETTERS);

    if (submitted) {
        const result = checkWordGuess(guess, answer);
        for (let i=0; i<result.length; i++) {
            if (result[i] == CheckedLetter.Correct) {
                checkedLetters[i] = {letter: guess[i], className: "correct"}
            } else if (result[i] == CheckedLetter.Incorrect) {
                checkedLetters[i] = {letter: guess[i], className: "incorrect"}
            } else if (result[i] == CheckedLetter.WrongSpot) {
                checkedLetters[i] = {letter: guess[i], className: "wrong-spot"}
            } else {
            }
        }
    } else {
        for (let i=0; i<MAX_LETTERS; i++) {
            //put the letters into square borders
            if (i < guess.length) {
                checkedLetters[i] = {letter: guess[i], className: "neutral"}
            } else {
                //insert empty boxes when there are no letters
                checkedLetters[i] = {letter: "", className: "neutral"}
            }
        }
    }

    return (
        <div className="square-row">
            {checkedLetters.map((letter: any) => (
                <div className={ `square ${ letter.className }` }>
                    <p className="letter">{ letter.letter }</p>
                </div>
            ))}
        </div>    
    );
}


